const translations = {
    noBoundariesFound: 'No boundaries found',
    search: 'Search'
};

export default translations;
